// Build-time configuration (Vite injects import.meta.env.VITE_*).
// Local dev leaves these blank -> relative /api (proxied to sam local) and no Auth0.
export const config = {
  // Production traffic goes through the web distribution's /api/* behavior.
  // Keep local development relative so Vite can proxy it to the local API.
  apiBaseUrl: (import.meta.env.VITE_API_BASE_URL ?? (import.meta.env.PROD ? 'https://provisioning-hub-mfe.dev.staff.naviance.com' : '')).replace(/\/+$/, ''),
  auth0Domain: import.meta.env.VITE_AUTH0_DOMAIN ?? '',
  auth0ClientId: import.meta.env.VITE_AUTH0_CLIENT_ID ?? '',
  auth0Audience: import.meta.env.VITE_AUTH0_AUDIENCE ?? '',
  // Local-dev staff identity: sent as x-staff-* headers so the security audit log
  // attributes actions to a user when the Auth0 authorizer is disabled locally.
  staffUsername: import.meta.env.VITE_STAFF_USERNAME ?? 'local.dev',
  staffEmail: import.meta.env.VITE_STAFF_EMAIL ?? 'local.dev@naviance.com',
  // Base URL for "Sign in to account" (product admin login). Appended with
  // ?highschoolId=<uuid>. Opens in a new tab.
  adminLoginUrl: import.meta.env.VITE_ADMIN_LOGIN_URL ?? 'https://id.naviance.com/admin-login',
};

// Auth is only enabled when a domain + client id are configured (i.e. deployed UI).
export const isAuthEnabled = Boolean(config.auth0Domain && config.auth0ClientId);
